export enum NotificationType {
  NEW_POST = 'new_post',
  INVITATION = 'invitation',
  ACCESS_APPROVED = 'access_approved',
}

export interface Notification {
  id: string;
  analystId: number;
  siteId: string;
  message: string;
  read: boolean;
  type: NotificationType;
  referenceId?: string; // postId for new_post, siteId for invite/access
  responseAccepted?: boolean; // true = accepted, false = declined
  createdAt: string; // ISO string
}

export interface NotificationCounts {
  total: number;
  unread: number;
  newContent: number;
  invitations: number;
  accessApproved: number;
}

export interface PaginatedNotificationsResponse {
  data: Notification[];
  total: number;
  hasMore: boolean;
}
